// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchRecommendations_container__V6ASa","topResultsContainer":"SearchRecommendations_topResultsContainer__4nR8F"};